import React from 'react';
import { AddToHomeScreen } from 'react-pwa-add-to-homescreen';
import {Link as RouterLink, Outlet} from "react-router-dom";
import {ThemeProvider, createTheme} from '@mui/material';
import {SheetProvider} from './context';
import FeatureAnnouncement from './components/FeatureAnnouncement';
import './styles/App.scss';

function App() {
  const LinkBehavior = React.forwardRef((props, ref) => {
    const { href, ...other } = props;
    if (href && href.startsWith('http')) {
      return <a href={href} ref={ref} {...other} /> // eslint-disable-line jsx-a11y/anchor-has-content
    }
    // Map href (MUI) -> to (react-router)
    return <RouterLink data-testid="custom-link" ref={ref} to={href} {...other} />;
  });
  const theme = createTheme({
    components: {
      MuiLink: {
        defaultProps: {
          component: LinkBehavior,
        },
      },
      MuiButtonBase: {
        defaultProps: {
          LinkComponent: LinkBehavior,
        },
      },
      // MuiAccordionSummary: {
      //   styleOverrides: {
      //     root: {
      //       '.MuiAccordionSummary-content.Mui-expanded': {
      //         margin: 'inherit',
      //       },
      //     },
      //   },
      // },
    },
  });

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <SheetProvider>
          <Outlet />
        </SheetProvider>
        <FeatureAnnouncement/>
      </ThemeProvider>
      <AddToHomeScreen cookie={{name:'lebspend-a2hs'}} />
    </div>
  );
}

export default App;
